import Vue from 'vue'
import VueChimera from 'vue-chimera'

Vue.use(VueChimera, {"ssrContext":"__NUXT__.chimera","prefetch":"override","prefetchTimeout":4000,"$options":{},"axios":function() {
      const token = this.$cookies.get("token");
      if (!!token) {
        this.$axios.setHeader("Authorization-token", `REST:${token}`);
      } else {
        this.$axios.setHeader("Authorization-token", false);
      }
      return this.$axios;
    }})

export default function ({ beforeNuxtRender, app }) {
    if (process.server) {
        const ChimeraSSR = require('vue-chimera/ssr')
        beforeNuxtRender(({ nuxtState }) => {
            nuxtState.chimera = ChimeraSSR.getStates()
        })
    }
}
